/**
 * Format a value as a US phone number: (123)-456-7890.
 * Keeps only digits (max 10) and formats progressively so it also works
 * while the user is still typing.
 */
export function formatPhoneNumber(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '';
  const digits = String(value).replace(/\D/g, '').slice(0, 10);
  const len = digits.length;
  if (len === 0) return '';
  if (len < 4) return `(${digits}`;
  if (len < 7) return `(${digits.slice(0, 3)})-${digits.slice(3)}`;
  return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
